export default "__VITE_ASSET__DLFVVdV7__"